export const buildThinkerTickPayload = ({
  model,
  username,
  threadId,
  allowWeakServiceContinue = false,
  participantId = '',
  participantName = '',
} = {}) => {
  const payload = {
    model,
    expect_json: true,
    mode: 'thinker',
    username,
    thread_id: threadId,
    allow_weak_service_continue: !!allowWeakServiceContinue,
  };
  if (participantId) payload.participant_id = participantId;
  if (participantName) payload.participant_name = participantName;
  return payload;
};

export const shouldDelayAutoThinkerAfterChat = (cooldownUntilMs, nowMs = Date.now()) =>
  Number(nowMs) < Number(cooldownUntilMs || 0);
